import { Component, OnInit } from '@angular/core';
import { durationStringToMinutes, MeetingType } from '@vendasta/meetings';
import { Observable, of, timer } from 'rxjs';
import {
  distinctUntilChanged,
  first,
  map,
  mapTo,
  switchMap,
} from 'rxjs/operators';
import { BookMeNowStoreService } from '../book-me-now-store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from '../navigation.service';

@Component({
  selector: 'app-bookme-meeting-type-selection-page',
  templateUrl: './bookme-meeting-type-selection-page.component.html',
  styleUrls: ['./bookme-meeting-type-selection-page.component.scss'],
  standalone: false,
})
export class BookmeMeetingTypeSelectionPageComponent implements OnInit {
  loadingForEnoughTime$: Observable<boolean>;
  meetingTypes$: Observable<
    (MeetingType & { name: string; hexColor: string; bookingUrl: string })[]
  >;
  hideTitleText$: Observable<boolean>;
  meetingTypeId$: Observable<string>;
  constructor(
    public readonly bookMeNowStoreService: BookMeNowStoreService,
    private readonly route: ActivatedRoute,
    private router: Router,
    public navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    const currentPath = this.router.url;
    this.bookMeNowStoreService.storeInitialPath(currentPath);

    this.meetingTypeId$ = this.bookMeNowStoreService.meetingTypeId$;
    this.loadingForEnoughTime$ = timer(500).pipe(first(), mapTo(true));
    const calendarSlug = this.route.snapshot.params.calendarId;
    this.meetingTypes$ = this.bookMeNowStoreService.calendarId$.pipe(
      distinctUntilChanged(),
      switchMap((calendarId) =>
        calendarId
          ? this.bookMeNowStoreService.loadMeetingTypes({
              calendarId,
              calendarSlug,
            })
          : of(undefined)
      )
    );
    this.hideTitleText$ = this.route.queryParams.pipe(
      map((params) => params?.hide_header === 'true')
    );
  }

  durationMinutes(duration: string): number {
    return durationStringToMinutes({ duration });
  }
}
